import * as S from '../../styles';
import NavbarContentItem from '../../NavbarContentItem';

type PdocastData = {
  tipo: string;
  link: string;
  prefixo: string;
  svg: string;
  links: unknown;
};
interface PropsActiveTab {
  isActive: boolean;
  newsTabPodcast: PdocastData;
  setOpen: (boolean) => void;
  setOption: (boolean) => void;
}
export default function PodcastTab({ isActive, newsTabPodcast, setOpen, setOption }: PropsActiveTab) {
  return (
    <S.ListNavbar className={isActive && 'show'}>
      <S.ListTitle>PODCASTS </S.ListTitle>
      {Object.entries(newsTabPodcast.links).map(link => (
        <NavbarContentItem link={link} setOpen={x => setOpen(x)} setOption={x => setOption(x)} key={link[0]} />
      ))}
    </S.ListNavbar>
  );
}
